<template>
  <div v-if="checkCreatePermission()">
    <vs-button
      @click="popupActivo3 = true"
      icon-pack="feather"
      icon="icon-plus"
      type="flat"
      class="w-full"
      >Folder</vs-button
    >
    <vs-popup
      classContent="popup-example"
      title="Create Sub folder"
      :active.sync="popupActivo3"
    >
      <vs-input
        placeholder="Folder Name"
        v-model="subfolderData.repository_name"
        class="mt-5 w-full"
      />

      <vs-button
        class="mt-5 w-full"
        :disabled="buttonActive"
        @click="onEnterSubfolder"
        color="primary"
        type="filled"
        >Create</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { create_folder, repoDetails } from '@/api/file.js'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
export default {
  name: 'createsubfolder',
  props: ['repo_id', 'repo_path'],
  mixins: [PermissionMiddleware],
  data () {
    return {
      subfolderData: {
        repository_name: '',
        repository_path: '',
        parent_repository_id: ''
      },
      popupActivo3: false,
      buttonActive: false,
      file1: []
    }
  },
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
      this.getModulePermission('Files')
    }
  },
  computed: {},
  methods: {
    addedSubFolder (allSubFolder) {
      this.$emit('addedSubFolder', allSubFolder)
    },

    onEnterSubfolder () {
      // eslint-disable-next-line eqeqeq
      if (this.subfolderData.repository_name != '') {
        this.buttonActive = !this.buttonActive
        this.subfolderData.repository_path = `${this.repo_path}/${this.subfolderData.repository_name}`
        this.subfolderData.parent_repository_id = this.repo_id

        create_folder(localStorage.getItem('customer_id'), this.subfolderData)
          .then((res) => {
            const afterCreate = res.data.data.repository
            this.addedSubFolder(afterCreate)
            this.subfolderData.repository_name = ''
            this.popupActivo3 = false
            this.buttonActive = false
            this.$vs.notify({
              title: 'Success',
              text: 'Your folder is created',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
            // repoDetails(localStorage.getItem('customer_id'), this.repo_id)
            //   .then((res) => {
            //     this.addedSubFolder(res.data.data.repository.sub_repository)
            //     this.subfolderData.repository_name = ''
            //     this.popupActivo3 = false
            //     this.buttonActive = false
            //   })
            //   .catch((e) => {

            //     this.subfolderData.repository_name = ''
            //     this.popupActivo3 = false
            //     this.buttonActive = false
            //     this.$vs.notify({
            //       title: 'Warning',
            //       text: 'Something Went Wrong',
            //       color: 'warning',
            //       iconPack: 'feather',
            //       icon: 'icon-alert-circle'
            //     })
            //   })
          })
          .catch((e) => {
            this.subfolderData.repository_name = ''
            this.popupActivo3 = false
            this.buttonActive = false
            this.$vs.notify({
              title: 'Warning',
              text: 'Something Went Wrong',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          })
      }
    }
  }
}
</script>